import React from "react";


type CircleProps = {
    color: string,
}

const Cross = ({color}: CircleProps) => {
    return(
        <div>
            <svg width="75%" height="75%" viewBox="0 0 236 236"
                 style={{fillRule:'evenodd',clipRule:'evenodd',strokeLinejoin:'round',strokeMiterlimit:2}}>
                <path d="M117.636,87.79l59.534,-61.173c4.007,-4.117 10.602,-4.207 14.718,-0.2l14.918,14.518c4.116,4.006 4.206,10.601 0.2,14.718l-60.324,61.983l60.324,61.983c4.006,4.116 3.916,10.711 -0.2,14.718l-14.918,14.518c-4.116,4.006 -10.711,3.917 -14.718,-0.2l-59.534,-61.173l-59.535,61.173c-4.006,4.117 -10.601,4.206 -14.718,0.2l-14.917,-14.518c-4.117,-4.007 -4.206,-10.602 -0.2,-14.718l60.323,-61.983l-60.323,-61.983c-4.006,-4.117 -3.917,-10.712 0.2,-14.718l14.917,-14.518c4.117,-4.007 10.712,-3.917 14.718,0.2l59.535,61.173Z"
                style={{fill: color}}/>
            </svg>
        </div>
    )
}

export default Cross;